import Module1 from 'src/assets/images/icBrandAppleSolid.svg';
import Module2 from 'src/assets/images/icBrandGooglePlaySolid.svg';
const appConfig={
  "serviceCode": "vividi",
  "supportedLanguages": [
    "en",
    "pt-BR",
    "hi",
    "tr",
    "ar"
  ],
  "defaultLanguage": "en",
  "appDownloadLinks": [
    {
      "url": "https://vividiapp.onelink.me/EyZ5/sxrak59w",
      "i18nKey": "BUTTON__APP_STORE",
      "type": "appstore",
      "icon": Module1
    },
    {
      "url": "https://vividiapp.onelink.me/EyZ5/sxrak59w",
      "i18nKey": "BUTTON__GOOGLE_PLAY",
      "type": "playstore",
      "icon": Module2
    }
  ],
  "layout": {
    "header": {
      "type": "APP_LIKE",
      "alwaysShowGemAmount": true,
      "tabsLocation": "center"
    },
    "showLoginModalOnPrivateRoute": true
  },
  "availableLoginMethods": [
    "google",
    "apple"
  ],
  "features": {
    "about": {
      "enabled": false
    },
    "followPage": {
      "enabled": false
    },
    "dm": {
      "enabled": false
    },
    "blog": {
      "enabled": false
    },
    "vip": {
      "enabled": false
    },
    "history": {
      "entry": "ROUTE"
    },
    "itemInventory": {
      "enabled": false
    },
    "profilePreferredLanguage": {
      "enabled": false
    },
    "userProfile": {
      "enabled": false
    }
  },
  "headers": {
    "x-azar-api-version": 9999,
    "x-app-type": "VIVIDI"
  },
  "helpCenterBaseUrl": "https://help.vividi.com",
  "helpCenterApiUrl": "https://vividi.zendesk.com/api/v2/help_center",
  "helpCenterSectionIds": {
    "termsOfService": 55906118160921,
    "privacyPolicy": 55906147442201,
    "locationBasedTerms": 55947121122585,
    "cookiePolicy": 55906118219161
  },
  "helpCenterArticleUrls": {
    "communityGuidelines": "https://help.vividi.com/hc/en-us/articles/55906134830233"
  },
  "webToAppModalConfig": {
    "url": "https://vividi.go.link/c0GeS"
  }
};export default appConfig;